export function getFormattedNumber(
  number?: number,
  {
    invalidResult,
    prefix,
    suffix,
    trimmed,
  }: {
    invalidResult?: string;
    prefix?: string;
    suffix?: string;
    trimmed?: boolean;
  } = {},
) {
  invalidResult = invalidResult || '-';
  if (number === undefined || number === null) return invalidResult;
  const formattedNumber = Intl.NumberFormat().format(+number);
  let result = formattedNumber;
  if (prefix && suffix) {
    result = `${prefix} ${formattedNumber} ${suffix}`;
  }
  if (prefix) {
    result = `${prefix} ${formattedNumber}`;
  }
  if (suffix) {
    result = `${formattedNumber} ${suffix}`;
  }
  return trimmed ? result.replaceAll(' ', '') : result;
}

export function truncateNumber(value: number, decimals: number) {
  const factor = 10 ** decimals;
  return Math.floor(value * factor) / factor;
}
